import React from "react";
import Cart from "../../components/common/Icons/Cart";
import * as styles from "./MyBasketIcon.module.scss";

export interface MyBasketIconProps {
	className: string;
	count: number;
}

export const MyBasketIcon: React.FC<MyBasketIconProps> = ({
	className,
	count,
}) => {
	return (
		<a
			className={className}
			href={process.env.GATSBY_SAD_BASKET_URL}
			aria-label={"Visit your basket"}
		>
			<Cart width="32" height="32" />
			<span className={styles.basketnotification} aria-hidden="true">
				{count}
			</span>
		</a>
	);
};

export default MyBasketIcon;
